import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EmptyView from './components/EmptyView';
import ErrorView from './components/ErrorView';
import LoadingOverlay from './LoadingOverlay';

const NoRowsOverlay = memo(
    ({ isLoading, hasError, emptyViewProps, errorViewProps, customEmptyViewComponent }) => {
        if (isLoading) return <LoadingOverlay />;
        let finalErrorViewProps;
        let finalEmptyViewProps;

        if (typeof errorViewProps === 'function') finalErrorViewProps = errorViewProps();
        else finalErrorViewProps = errorViewProps;
        if (typeof emptyViewProps === 'function') finalEmptyViewProps = emptyViewProps();
        else finalEmptyViewProps = emptyViewProps;

        return hasError ? (
            <ErrorView {...finalErrorViewProps} />
        ) : (
            <EmptyView {...finalEmptyViewProps} />
        );
    },
);

NoRowsOverlay.propTypes = {
    errorViewProps: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
        }),
    ]),
    emptyViewProps: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            icon: PropTypes.node,
            title: PropTypes.string,
            subtitle: PropTypes.string,
        }),
    ]),
};

export default NoRowsOverlay;
